import React from "react";
import TextInput from './TextInput'
import TimeInput from './TimeInput'
import TextNumberInput from './TextNumberInput'
import SelectInput from './SelectInput'
import FixButton from './Button'
import AddMeetingService from '../services/addMeeting';
import GetEventService from '../services/getEvent';
import Cookies from 'universal-cookie';
import moment from 'moment';
import ManageBreak from "../services/manageBreak";
import Utils from '../utils/utils';

export default class EditBreakWidget extends React.Component {

    constructor (props){
        super(props);

        this.selectRef = React.createRef();
        this.selectBreakRef = React.createRef();
        
        let breakTime = Utils.roundTime(this.props.break.hour) + ":" + Utils.roundTime(this.props.break.minutes);
        
        this.subjects = [];
        this.state = {
            visible: false,
            selected: 'event',
            time: breakTime
        }

        this.timeRef = React.createRef();
    }

    async componentDidMount(){
        let scheduleType = this.props.scheduleType;
        this.subjects = [];
        if (scheduleType == 'investor'){
            this.optionsLabel = "Companies";
            this.props.companies.map(company => this.subjects.push({value: company.id, label: company.name}));
        }
        if (scheduleType == 'company'){
            this.optionsLabel = "Investors";
            this.props.investors.map(investor => this.subjects.push({value: investor.id, label: investor.name}));
        }

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const eventId = cookies.get('currentEventId', { path: '/' });

        this.event = await GetEventService(username, token, eventId);

        this.breaksType = [
            {value: 1, label: 'Lunch break'}, 
            {value: 2, label: 'Coffee break'},
            {value: 3, label: 'Unavailable'}
        ];
        
        this.event.customBreaks.split(';').map(b => {
            this.breaksType.push({value: this.breaksType.length + 1, label: b});
        })

        var currentSelection = {};
        for (var i = 0; i < this.breaksType.length; i++){
            if (this.breaksType[i].label == this.props.break.break_type)
                currentSelection = this.breaksType[i]
        }

        this.setState({
            visible: this.props.visible,
            scheduleType: scheduleType,
            break_type: currentSelection,
            slots: this.props.break.slots,
        });

        // this.timeRef.focus();
    }

    render (){

        let st = Object.assign({display: this.state.visible ? 'block' : 'none'}, mainClass)

        return ( 
        <div key={Math.random()} style={st} >
            <div style={closeIcon} onClick={() => {
                this.setState({visible: false});
                this.props.onDone();
            }}>X</div>            
            <div style={{marginTop: '10px'}}>
                <div className="windowTitle">Edit break</div>
                <TextInput readOnly={true} name={"Date"} value={this.props.break.date} />
                <TimeInput autoFocus ref={this.timeRef} readOnly={true} name={"Time"} value={this.state.time} onChange={(val) => 
                    this.setState({time: val}) }/>

                <SelectInput key={Math.random()} 
                    ref={this.selectBreakRef}
                    value={this.state.break_type} 
                    name={"Break type"} 
                    options={this.breaksType} 
                    onChange={(option) => 
                        this.setState({break_type: option})} 
                    />
                <TextNumberInput name={"Slot duration"} value={this.state.slots * 5} onChange={(val) => 
                    this.setState({slots : val / 5,
                                    value: this.state.value})}/>
                <FixButton title={'Save'} callback={this.saveBreak.bind(this)} />
                <FixButton title={'Delete'} callback={this.deleteBreak.bind(this)} />
            </div>
        </div>
        )
    }


    async deleteBreak(){

       if (window.confirm("Delete the break?")) {

            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
            const currentEventId = cookies.get('currentEventId', { path: '/' });
    
            var selectedValues = this.selectBreakRef.current.getValue();
            if (selectedValues == undefined || selectedValues.length <= 0) return;

            let ret = await ManageBreak(username, token, currentEventId, this.props.break.id, this.state.date, this.props.break.hour, 
                this.props.break.minutes, this.props.break.slots, this.props.break.type,
                this.props.break.subject, this.props.break.type, true);

            this.props.onDone();
       }
    }

    async saveBreak(){

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const currentEventId = cookies.get('currentEventId', { path: '/' });

        var selectedValues = this.selectBreakRef.current.getValue();
        if (selectedValues == undefined || selectedValues.length <= 0) return;

        let breaks = [];
        this.props.breaks.map(b => {
            if (b.id != this.props.break.id)
                breaks.push(b);
        });

        let hh = this.state.time.split(':')[0];
        let mm = this.state.time.split(':')[1];

        if (Utils.checkBreakPossible(this.props.meetings, breaks, this.props.scheduleType, this.props.subjectId, 
            this.props.break.date, hh, mm, this.state.slots) == false){
            return;
        }

        let ret = await ManageBreak(username, token, currentEventId, this.props.break.id, this.state.date, hh, 
            mm, this.state.slots, this.props.break.type, 
            this.props.break.subject, this.state.break_type.label, false);

        this.props.onDone();

    }



    checkInvestor(investors, id){
        investors.map(v => {
            if (v.id == id) return true;
        });
        return false;
    }    

    handleChangeMultiple = (event) => {
        const { options } = event.target;
        const value = [];
        for (let i = 0, l = options.length; i < l; i += 1) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        this.setState({value: value})
      };

}


const menu = {
    position: 'relative',
    top: '10px',
    display: 'flex',
};

const menuVoice = {
    width: '50%',
    textAlign: 'center',
    border: '1px solid black',
    cursor: 'pointer'
}

const title = {
    top: '10xp',
    width: '100%',
    height: '40px',
    lineHeight: '40px',
    textAlign: 'center',
};

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 0, 
    top: 0, 
    padding: 10
}

const mainClass = {
    position: 'fixed',
    left: '35%',
    top: '10%',
    background: '#ffffff',
    border: '1px solid black',
    padding: '20px',
    overflow: 'scroll',
    height: '600px',
    zIndex: 999

}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}


const inputTextDisabled = {
    background: '#eeeeee',
    width: '300px',
    padding: '10px'
}